import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpService } from '../services/http.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-service-selection',
  templateUrl: './service-selection.component.html',
  styleUrls: ['./service-selection.component.sass']
})
export class ServiceSelectionComponent implements OnInit, OnDestroy {

  labels: any;

  labelsObsSub: any;
  langObsSub: any;

  constructor(http: HttpService, language: LanguageService) {
    this.labelsObsSub = http.labelsObservable().subscribe((labels: object) => {
      this.labels = labels;
    });
    this.langObsSub = language.languageObs().subscribe((lang: string) => {
      http.getLabels('service-selection-labels', lang);
    });
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.labelsObsSub.unsubscribe();
    this.langObsSub.unsubscribe();
  }

}
